export const iconFontAwesomeMedicalHealthWheelchair = (
	<i className="fa-solid fa-wheelchair"></i>
);
